export default {
  getFertilizers(data) {
    return env.API.post('/user/fertilizer/all', data);
  },
  getFertilizersForBaseDressing(data) {
    // return env.API.post('/user/fertilizer/all/baseDressing', data);
     return env.API.post('/user/fertilizer/all/baseDressing', data);
  },
  getFertilizer(id) {
    return env.API.post('/user/fertilizer/get', {fertilizerId: id});
  },

  setFertilizersProgram(data) {
    return env.API.post('/user/program/selectFertilizers', data).then((res) => {
      // console.log(res);
    });
  },
  getSelectedFertilizersProgram(programId) {
    return env.API.post('/user/program/getSelectedFertilizers', programId);
  },
  deletSelectedFertilizersProgram(data) {
    return env.API.post('/user/program/deleteSelectedFertilizer', data);
  },
  updatePercentProgram(data) {
    return env.API.post('/user/program/editPercentageSelectedFertilizers', data);
  },

  setFertilizersDressing(data) {
    return env.API.post('/user/program/selectFertilizersForBaseDressing', data);
  },
  dropBaseDressingFertilizers(data) {
    return env.API.post(`/user/program/baseDressing/empty`, data)
  },
  dropScheduleFertilizers(data) {
    return env.API.post(`/user/program/fertilizerSchedule/empty`, data)
  },
  getSelectedFertilizersDressing(programId) {
    return env.API.post('/user/program/getSelectedFertilizersForBaseDressing', programId);
  },
  deletSelectedFertilizersDressing(data) {
    return env.API.post('/user/program/deleteSelectedFertilizerForBaseDressing', data);
  },
  updatePercentDressing(data) {
    return env.API.post('/user/program/editPercentageSelectedFertilizersForBaseDressing', data);
  },
  updateQuantityBaseDressing(data) {
    return env.API.post('/user/program/editQuantitySelectedFertilizers', data);
  },
  updateFertilizersBaseDressing(data) {
    return env.API.post('/user/program/selectFertilizersForBaseDressing', data);
  },

  createFertilizer(data) {
    return env.API.post('/user/fertilizer/create', data);
  },
  editFertilizer(data) {
    return env.API.post('/user/fertilizer/edit', data);
  },
  deleteFertilizer(id) {
    return env.API.post('/user/fertilizer/delete', { fertilizerId: id });
  },

  saveFertilizerCost(data) {
    return env.API.post('/user/fertilizer/cost/save', data)
  }

}
